import { render, staticRenderFns } from "./ColumnList.vue?vue&type=template&id=39d7bdbd&scoped=true&"
import script from "./ColumnList.vue?vue&type=script&lang=js&"
export * from "./ColumnList.vue?vue&type=script&lang=js&"
import style0 from "./ColumnList.vue?vue&type=style&index=0&id=39d7bdbd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d7bdbd",
  null
  
)

export default component.exports